import { Mail, MapPin } from "lucide-react";
import { scrollToHash } from "./Navbar";

const SERVICE_LINKS = [
    { label: "Performance Marketing", href: "#services" },
    { label: "Search Engine Optimization", href: "#services" },
    { label: "AI Integration & Automation", href: "#services" },
    { label: "Lead Generation", href: "#services" },
];

const COMPANY_LINKS = [
    { label: "Our approach", href: "#approach" },
    { label: "Case studies", href: "#results" },
    { label: "Pricing", href: "#pricing" },
    { label: "FAQ", href: "#faq" },
    { label: "Contact", href: "#contact" },
];

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="footer-container"
            className="bg-navy-deep border-t border-gold/15"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <img
                        data-testid="footer-brand-logo"
                        src="/logos/smartnet-reversed-transparent.webp"
                        alt="SMART NET"
                        className="h-10 w-auto"
                    />
                    <p className="mt-6 max-w-sm text-sm text-mist leading-relaxed">
                        A Florida growth agency fusing marketing, SEO, AI
                        integration and lead generation into one revenue
                        engine for ambitious companies.
                    </p>
                    <div className="mt-6 space-y-3">
                        <a
                            href="mailto:smartnetincca@gmail.com"
                            data-testid="footer-email-link"
                            className="flex items-center gap-3 text-sm text-white hover:text-gold transition-colors break-all"
                        >
                            <Mail size={16} className="text-gold shrink-0" />
                            smartnetincca@gmail.com
                        </a>
                        <p className="flex items-start gap-3 text-sm text-mist">
                            <MapPin size={16} className="text-gold shrink-0 mt-0.5" />
                            <span>
                                200 E Las Olas Blvd, Fort Lauderdale,
                                <br />
                                FL 33301, United States
                            </span>
                        </p>
                    </div>
                </div>

                <div className="lg:col-span-2">
                    <h4 className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">
                        Services
                    </h4>
                    <ul className="mt-5 space-y-3">
                        {SERVICE_LINKS.map((l) => (
                            <li key={l.label}>
                                <a
                                    href={l.href}
                                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        scrollToHash(l.href);
                                    }}
                                    className="text-sm text-mist hover:text-gold transition-colors"
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-2">
                    <h4 className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">
                        Company
                    </h4>
                    <ul className="mt-5 space-y-3">
                        {COMPANY_LINKS.map((l) => (
                            <li key={l.label}>
                                <a
                                    href={l.href}
                                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        scrollToHash(l.href);
                                    }}
                                    className="text-sm text-mist hover:text-gold transition-colors"
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-3">
                    <h4 className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">
                        Legal & registered details
                    </h4>
                    <p className="mt-5 text-xs text-mist leading-relaxed space-y-2">
                        SMART NET INC is a Florida Corporation, Company Number
                        P21000077038.
                        <br />
                        <br />
                        Registered address: 729 NW 8th Ave, Fort Lauderdale, FL
                        33311.
                        <br />
                        <br />
                        Business address: 200 E Las Olas Blvd, Fort Lauderdale,
                        FL 33301, United States.
                        <br />
                        <br />
                        General Manager: Ren Fi Tal
                    </p>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-xs text-mist">
                        © {year} SMART NET INC. All rights reserved.
                    </p>
                    <a
                        href="/admin"
                        data-testid="footer-admin-link"
                        className="font-mono text-[11px] uppercase tracking-widest text-mist/60 hover:text-gold transition-colors"
                    >
                        Admin lead inbox
                    </a>
                </div>
            </div>
        </footer>
    );
}
